import React from 'react';
import './ActionIcon.css';

const ICONS = {
  edit: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4.5 16.9 15.8 5.6a1.6 1.6 0 0 1 2.3 0l1.3 1.3a1.6 1.6 0 0 1 0 2.3L8.1 20.5H4.5z" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round" />
      <path d="M14.2 7.2 17.8 10.8" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
    </svg>
  ),
  delete: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 7.5h14" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
      <path d="M9.2 7.4V5.8A1.3 1.3 0 0 1 10.5 4.5h3a1.3 1.3 0 0 1 1.3 1.3v1.6" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 7.5h8l-.6 11.1a1.6 1.6 0 0 1-1.6 1.5H10.2a1.6 1.6 0 0 1-1.6-1.5z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  ),
  approve: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6.5 12.4 10.2 16l7.3-8.2" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  complete: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6.5 12.4 10.2 16l7.3-8.2" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  reject: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7.5 7.5 16.5 16.5M16.5 7.5 7.5 16.5" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
    </svg>
  ),
  review: (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="6.2" fill="none" stroke="currentColor" strokeWidth="1.9" />
      <path d="M16 16.2 20 20" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
    </svg>
  )
};

const ActionIcon = ({ type = 'edit', title, onClick, className = '' }) => (
  <button
    type="button"
    className={`action-icon action-icon-${type} ${className}`.trim()}
    title={title}
    aria-label={title}
    onClick={onClick}
  >
    {ICONS[type] || ICONS.edit}
  </button>
);

export default ActionIcon;
